<template>
  <div>
    <div class="card-body print-form">
      <header class="clearfix">
        <div id="logo">
          <img src="../../assets/img/logo81-min.png" />
        </div>
        <div id="company" class="clearfix">
          <div class="refnumsize">{{ GetShopInfo?GetShopInfo.name:"" }}</div>
          <div
            v-if="
            GetShopInfo.address &&
              GetShopInfo.address.address_line1 &&
                GetShopInfo.address.city &&
                GetShopInfo.address.country.name
            "
          >
            {{ GetShopInfo.address? GetShopInfo.address.address_line1:"" }},
            {{ GetShopInfo.address?GetShopInfo.address.city:"" }},
            {{ GetShopInfo.address.country?GetShopInfo.address.country.name:"" }},
          </div>
          <div>
            <a href="mailto:company@example.com">{{
              GetShopInfo.contact? GetShopInfo.contact.phone:""
            }}</a
            ><a
              v-if="GetShopInfo.contact && GetShopInfo.contact.telephone && GetShopInfo.contact.phone"
              >/</a
            >
            <a href="mailto:company@example.com">{{
              GetShopInfo.contact? GetShopInfo.contact.telephone:""
            }}</a>
          </div>

          <div>
            <a href="mailto:company@example.com">{{
              GetShopInfo.contact?GetShopInfo.contact.email:""
            }}</a>
          </div>
        </div>
        <div id="customer" class="clearfix">
          <div>Reference No:- {{ data != null && (data.reference_number ? data.reference_number:"") }}</div>

          <div>Valid Date:-{{ data != null && ( data.valid_date | formatDate ) }}</div>

          <div>Customer:-{{ data != null && (data.customer.name?data.customer.name:"") }}</div>

          <div>Create By:-{{ data != null && (data.biller.first_name?data.biller.first_name :"") }}</div>

          <div>Shop:-{{ data != null && (data.shop.name?data.shop.name:"" )}}</div>
        </div>
      </header>

      <main>
        <table>
          <tbody>
            <tr v-if="data != null && (data.quotationItem.length != 0)">
              <td class="text-left" colspan="8">Products</td>
            </tr>
            <tr v-if="data != null && (data.quotationItem.length != 0)">
              <th class="text-center">No</th>
              <th class="text-center">Name</th>
              <th class="text-center">Unit</th>
              <th class="text-center">Batch</th>
              <th class="text-center">Quantity</th>
              <th class="text-center">Unit Cost</th>
              <th class="text-center">Discount%</th>
              <th class="text-center">Amount</th>
            </tr>
            <tr v-for="(item, index) in data != null && data.quotationItem" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.product.name }}</td>
              <td>{{ item.unit.name }}</td>
              <td>{{ item.batch.batch }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.batch.selling_price }}</td>
              <td>{{ item.discount }}</td>
              <td>{{ item.quantity * (item.amount - item.discount) }}.00</td>
            </tr>

            <tr v-if="data != null && (data.quotationServices.length != 0)">
              <td class="text-left" colspan="8">Services</td>
            </tr>
            <tr v-if="data != null && (data.quotationServices.length != 0)">
              <th class="text-center">No</th>
              <th class="text-center" colspan="4">Name</th>
              <th class="text-center">Amount</th>
              <th class="text-center">Discount%</th>
              <th class="text-center">Amount</th>
            </tr>
            <tr v-for="(item, index) in data != null && data.quotationServices" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td colspan="4">{{ item.service.name }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.discount }}</td>
              <td>{{ item.amount - item.discount }}.00</td>
            </tr>
            <tr class="black--text">
              <td class="hide" colspan="5"></td>

              <td><strong class="text-dark">Total</strong></td>
              <td class="hide">{{ data != null && data.discount }}</td>
              <td class="hide">{{ data != null && data.total }}</td>
            </tr>
          </tbody>
        </table>
      </main>
    </div>
    <b-btn
      @click="print"
      variant="primary"
      class="mt-1 pt-3 pb-3 font-poppins font-weight-bold w-100"
      >Print</b-btn
    >
    <QutationTemplate
      :quotationdata="data"
      class="test1"
      style="display: none"
      ref="printquotation"
    >
    
    </QutationTemplate>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import QutationTemplate from './QutationTemplate';

export default {
  name: 'PrintBill',
  data: function() {
    return {
      reference_number:null,
      isDiscountAdd: true,
    };
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },

  computed: {
    ...mapGetters('auth', ['GetUserName']),
    ...mapGetters('masterData', ['GetOrganization']),
    ...mapGetters('shops', ['GetShopInfo']),
  },
  components: {
    QutationTemplate
  },
  methods: {
    print() {
      this.$refs.printquotation.prints();
    },
  },
};
</script>
<style scoped>
.clearfix:after {
  content: '';
  display: table;
  clear: both;
}

a {
  color: #5d6975;
  text-decoration: underline;
}

body {
  position: relative;
  width: 22cm;
  height: 29.7cm;
  margin: 0 auto;
  color: #001028;
  background: #ffffff;
  font-size: 14px;
}
table,
td,
th {
  border: 1.5px solid black;
}

table {
  border-collapse: collapse;
  width: 100%;
}

header {
  padding: 10px 0;
  margin-bottom: 30px;
}

#logo {
  margin-bottom: 1px;
  float: right;
}

#logo img {
  width: 130px;
}

h1 {
  border-top: 1px solid #5d6975;
  border-bottom: 1px solid #5d6975;
  color: #5d6975;
  font-size: 2.4em;
  line-height: 1.4em;
  font-weight: normal;
  text-align: center;
  margin: 0 0 20px 0;
}

#supplier {
  float: left;
}

#supplier span {
  color: #5d6975;
  width: 60px;
  display: inline-block;
  font-size: 0.8em;
  margin-right: 20px;
}

#company {
  float: right;
  text-align: right;
}

#customer {
  float: left;
  text-align: left;
}
#supplier div,
#company div {
  white-space: nowrap;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
}

table tr:nth-child(2n-1) td {
  background: #f5f5f5;
}

table th,
table td {
  text-align: center;
}

table th {
  padding: 5px 20px;
  color: #5d6975;
  border-bottom: 1px solid #c1ced9;
  white-space: nowrap;
  font-weight: bold;
}

table .code,
table .name {
  text-align: left;
}

table td {
  padding: 6px;
  text-align: center;
}

table td.code,
table td.name {
  vertical-align: top;
}

table td.grand {
  border-top: 1px solid #5d6975;
}

#notices .notice {
  color: #5d6975;
  font-size: 1.2em;
}
.refnumsize {
  font-size: large;
  font-weight: bold;
}

footer {
  color: #5d6975;
  width: 100%;
  height: 30px;
  position: absolute;
  bottom: 0;
  border-top: 1px solid #c1ced9;
  padding: 8px 0;
  text-align: center;
}
</style>
